import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import SideNav from "./SideNav";
import { fetchProfile } from "../../services/api";

/**
 * SosContacts – quick‑access page for urgent contact with Digis project coordinators.
 * Displays four coordinators in a 2×2 grid, each with photo, email, and a Calendly link.
 */
const SosContacts = () => {
  const [profile, setProfile] = useState(null);
  const token = localStorage.getItem("authToken");
  const navigate = useNavigate();

  useEffect(() => {
    const loadProfile = async () => {
      try {
        const data = await fetchProfile(token);
        setProfile(data);
      } catch (err) {
        console.error("Error fetching profile in SosContacts:", err);
      }
    };
    loadProfile();
  }, [token]);

  const handleLogout = () => navigate("/logout");

  const coordinators = [
    {
      id: 1,
      name: "Artur Kyrychenko",
      email: "a.kyrychenko@digiscorp.com",
      avatar: "https://res.cloudinary.com/dnbbm9vzi/image/upload/v1751798715/510983938_23890267393994766_9119521015298206175_n_qabsvi.jpg",
      calendly: "https://calendly.com/a-kyrychenko-digis/",
    },
    {
      id: 2,
      name: "Kareem Khalil",
      email: "k.khalil@digiscorp.com",
      avatar: "https://res.cloudinary.com/dnbbm9vzi/image/upload/v1751797047/1518554998512_ojxcct.jpg",
      calendly: "https://calendly.com/kareem_digis",
    },
  ];

  return (
    <div className="dashboard-background">
      <div className="container-fluid">
        <div className="row">
          {/* Sidebar */}
          <SideNav userProfile={profile} handleLogout={handleLogout} />

          {/* Main Content */}
          <main
            className="col-md-9 ms-sm-auto col-lg-10 px-4 d-flex flex-column"
            style={{ minHeight: "100vh" }}
          >
            {/* Logo & heading */}
            <div className="text-center mt-3 mb-4 d-flex align-items-center justify-content-center">
              <img
                src="https://res.cloudinary.com/dnbbm9vzi/image/upload/v1747769920/logo_oq3zwy.png"
                alt="Logo"
                style={{ width: 50, height: 50, marginRight: 10 }}
              />
              <h1 className="d-inline mb-0 fw-bold">Digis Customer Portal</h1>
            </div>

            {/* SOS Section */}
            <div className="flex-grow-1 d-flex flex-column align-items-center w-100">
              <h2 className="fw-bold text-center mt-3">Support on Standby (SoS)</h2>
              <p className="text-center text-dark fs-5 mb-4">
                Need immediate assistance? Reach out to one of our project coordinators below.
              </p>

              {/* Coordinators Card */}
              <div className="row g-4 w-100">
                {coordinators.map(({ id, name, email, avatar, calendly }) => (
                  <div key={id} className="col-12 col-md-6">
                    <div
                      className="card custom-card text-center p-3 bg-transparent" // bg-transparent so image shows
                      style={{
                        backgroundImage:
                          'url("https://res.cloudinary.com/dnbbm9vzi/image/upload/v1749666438/Main_Page_soqhly.png")',
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                        borderRadius: ".5rem",
                      }}
                    >
                      <img
                        src={avatar}
                        alt={name}
                        className="rounded-circle mx-auto mb-3"
                        style={{ width: 240, height: 240, objectFit: "cover" }}
                      />

                      <h5 className="fw-bold mb-1 text-dark">{name}</h5>

                      <div className="d-inline-flex align-items-center justify-content-center gap-2 mb-3 mt-3">
                        <span className="text-primary fw-semibold selectable-text">{email}</span>
                        <a href={`mailto:${email}`} className="text-primary" aria-label="Email this person">
                          <i className="bi bi-envelope-fill"></i>
                        </a>
                      </div>

                      <a
                        href={calendly}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-outline-primary fw-bold mt-3"
                      >
                        Book a Call
                      </a>
                    </div>
                  </div>
                ))}
              </div>

            </div>
          </main>
        </div>
      </div>
    </div>
  );
};

export default SosContacts;
